import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard, type IDropdownItem, Status } from 'shared/ui'
import { type IContactsDataParams } from 'entities/Contacts/api/types'
import { useSurveySendStore } from 'widgets/SurveySend/lib/useSurveySendStore'
import styles from './styles.module.scss'

type ISurveySendActionProps = {
  contactsData: IContactsDataParams
  onClick?: () => void
}

export const SurveySendAction = observer(({ contactsData, onClick }: ISurveySendActionProps) => {
  const [loading, setLoading] = useState(false)
  const store = useSurveySendStore()

  const { selectedIds, bulkAll, contactsParams, search } = contactsData

  const handleClick = () => {
    if (bulkAll) {
      store.enrollContactsByFilters(contactsParams?.filtersList, search, bulkAll)
      onClick?.()
    } else {
      setLoading(true)
      store.getValidContactIds(selectedIds).then((validContactIds) => {
        setLoading(false)
        onClick?.()

        if (validContactIds) store.enrollContacts(validContactIds)
      })
    }
  }

  const disabled = loading

  const item: IDropdownItem = {
    id: 'send_survey',
    iconL: 'clipboardCheck',
    label: store.label,
    disabled,
    labelContent: (
      <div className={styles.dropdownLabel}>
        {store.label}
        <Status
          title={'New'}
          intent={'purple'}
          emphasis={'high'}
          size={'label'}
          disabled={disabled}
        />
      </div>
    ),
  }
  return <DropdownCard item={item} onChange={handleClick} />
})
